import { useState } from 'react';

interface UseSearchResultsLoadMoreOptions {
  isLoading: boolean;
  hasNextPage: boolean;
  fetchMoreVipAds?: () => Promise<unknown>;
  fetchMoreLatestAds?: () => Promise<unknown>;
}

export function useSearchResultsLoadMore({
  isLoading,
  hasNextPage,
  fetchMoreVipAds,
  fetchMoreLatestAds,
}: UseSearchResultsLoadMoreOptions) {
  const [isLoadingMore, setLoadingMore] = useState(false);

  function onLoadMore() {
    if (isLoading || isLoadingMore || !hasNextPage || !navigator.onLine) return;

    setLoadingMore(true);

    const promises: Promise<unknown>[] = [];
    if (fetchMoreVipAds) promises.push(fetchMoreVipAds());
    if (fetchMoreLatestAds) promises.push(fetchMoreLatestAds());

    Promise.all(promises).finally(() => setLoadingMore(false));
  }

  return { isLoadingMore, onLoadMore };
}
